import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { ResponsePackage } from "../models/util.model";
import { EmcDataIn, EmcOptions } from "../models/entity-model-customization.model";
import { Observable } from "rxjs";
import { GetEMCConfigurationDataIn, SaveConfigurationDataIn } from "../models/entityModelCustomization.model";
import { SHARED_LIB_CONFIG, SharedLibConfig } from "../config/lib-config";
import { CimClass } from "../models/network-structure.model";


@Injectable({
    providedIn: 'root',
})
export class EntityModelCustomizationService {
    private pathApi: string;
    constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
        this.pathApi = this.config.pathApi + 'entityModelCustomization/';
    }

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    
   getEmcOptions(
    entityType: number,
    purpose: number,
    utilityId: number,
    substationTemplateId?: number,
    cimClass?: CimClass
  ) {
    const url = `${this.pathApi}getEmcOptions/${entityType}/${purpose}/${utilityId}`;

    let params = undefined;
    if (substationTemplateId != null) {
      params = new HttpParams().set(
        'substationTemplateId',
        substationTemplateId.toString()
      );
    }

    if (cimClass != null) {
      params = new HttpParams().set(
        'cimClass',
        cimClass.toString()
      );
    } 

    return this.http.get<ResponsePackage<EmcOptions[]>>(url, {
      headers: this.headers,
      observe: 'response',
      params: params,
    });
  }

  getSelectedEmcOptions(
    entityType: number,
    purpose: number,
    utilityId: number,
    substationTemplateId?: number,
    cimClass?: CimClass
  ) {
    const url = `${this.pathApi}getSelectedEmcOptions/${entityType}/${purpose}/${utilityId}`;

    let params = undefined;
    if (substationTemplateId != null) {
      params = new HttpParams().set(
        'substationTemplateId',
        substationTemplateId.toString()
      );
    }

    if (cimClass != null) {
      params = new HttpParams().set(
        'cimClass',
        cimClass.toString()
      );
    } 

    return this.http.get<ResponsePackage<EmcOptions[]>>(url, {
      headers: this.headers,
      observe: 'response',
      params: params,
    });
  }

  getSelectedEmcOptionsForUtility(
    entityType: number,
    purpose: number,
    substationTemplateId?: number,
    cimClass?: CimClass
  ) {
    const url = `${this.pathApi}getSelectedEmcOptionsForUtility/${entityType}/${purpose}`;

    let params = undefined;
    if (substationTemplateId != null) {
      params = new HttpParams().set(
        'substationTemplateId',
        substationTemplateId.toString()
      );
    }
    if (cimClass != null) {
      params = new HttpParams().set(
        'cimClass',
        cimClass.toString()
      );
    }

    return this.http.get<ResponsePackage<EmcOptions[]>>(url, {
      headers: this.headers,
      observe: 'response',
      params: params,
    });
  }

  getSelectedEmcOptionsForFilter(
    entityType: number,
    purpose: number,
    substationTemplateId?: number,
    cimClass?: number
  ) {
    const url = `${this.pathApi}getSelectedEmcOptionsForFilter/${entityType}/${purpose}`;

    let params = new HttpParams();
    if (substationTemplateId != null) {
      params = params.set('substationTemplateId', substationTemplateId.toString());
    }
    if (cimClass != null) {
      params = params.set('cimClass', cimClass.toString());
    }

    return this.http.get<ResponsePackage<EmcOptions[]>>(url, {
      headers: this.headers,
      observe: 'response',
      params: params,
    });
  }

  getConfigurationByType(obj: GetEMCConfigurationDataIn): Observable<any> {
    return this.http.post(`${this.pathApi}getConfigurationByEntityModel`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  saveConfiguration(obj: SaveConfigurationDataIn): Observable<any> {
    return this.http.post(`${this.pathApi}saveConfiguration`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  saveEmcOptions(dataIn: EmcDataIn) {
    return this.http.post(`${this.pathApi}saveEmcOptions`, dataIn, {
      observe: 'response',
    });
  }
}